import React from "react";

const FooterBlank = () => {
  return <div className="footer"></div>;
};

export default FooterBlank;
